// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".goal-preview-stats .cover[data-v-392ab227]{border-radius:4px;margin-bottom:1rem;overflow:hidden;width:350px;height:180px}.goal-preview-stats .cover img[data-v-392ab227]{-o-object-fit:cover;object-fit:cover;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
